export const MANUAL_ADJUSTMENT_RATE_COMPONENT_DESCRIPTION = 'Manual Adjustment';

export const DEFAULT_QUOTE_CONFIDENCE_FILTER = {
  min: 0.5,
  max: 1.0,
};
